<template>
    <div>
        <h2>档口类别管理</h2>
        <el-row>
            <el-col :span="4">
                <el-button size="small" @click="addFormVisible = true" style="margin-bottom:10px;">新增</el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table :data="tableData" border stripe style="width: 100%">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="TYPE" label="档口类别"></el-table-column>
                    <el-table-column fixed="right" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-edit" size="small" @click="update(scope.row)">修改</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <div class="block">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
                layout="total,prev, pager, next, jumper" :total="totalNum">
            </el-pagination>
        </div>
        <el-dialog title="新增档口类别" center :visible.sync="addFormVisible" width="600px" :close-on-click-modal="false">
            <el-form :model="addForm" ref="addForm" style="margin-top: 0">
                <el-form-item label="名称：" :label-width="formLabelWidth" prop="NAME">
                    <el-input v-model="addForm.NAME" auto-complete="off" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close('addForm')">取 消</el-button>
                <el-button @click="submitAdd('addForm')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改档口类别" center :visible.sync="updateFormVisible" width="600px" :close-on-click-modal="false">
            <el-form :model="updateForm" ref="updateForm" style="margin-top: 0">
                <el-form-item label="名称：" :label-width="formLabelWidth">
                    <el-input v-model="updateForm.TYPE" auto-complete="off" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeEdit()">取 消</el-button>
                <el-button @click="submitedit('updateForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import http from '@/api/base/http';

export default {
  data() {
    return {
      updateForm: {},
      updateFormVisible: false,
      // loading:false,
      tableData: [],
      totalNum: 0,
      formLabelWidth: '100px',
      addFormVisible: false,
      pageSize: 10,
      currentPage: 1,
      addForm: {},

    };
  },
  created() {
    this.queryTable();
  },
  methods: {
    closeEdit() {
      this.updateFormVisible = false;
      this.queryTable();
    },
    update(row) {
      this.updateForm = row;
      this.updateFormVisible = true;
    },
    submitedit() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10005',
            OTYPE: 10,
            NAME: this.updateForm.TYPE,
            ID: this.updateForm.STATUS,
          };
          http.post(params)
            .then((result) => {
              this.$message.show({ text: '修改成功', type: 'success' });
              this.updateFormVisible = false;
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.updateFormVisible = false;
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    queryTable() {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 5,
        TC_ID: Number(sessionStorage.getItem('companyId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      http.post(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[1].list;
            this.totalNum = result[0].TOTAL;
          } else {
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    close() {
      this.addFormVisible = false;
      this.addForm = {};
    },
    submitAdd() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10005',
            OTYPE: 9,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            NAME: this.addForm.NAME,
          };
          // this.loading = true
          http.post(params)
            .then((result) => {
              this.$message.show({ text: '新增成功', type: 'success' });
              this.addFormVisible = false;
              this.queryTable();
              // this.loading = false
              document.body.style.cursor = 'default';
            }).catch((error) => {
              // this.loading = false
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
  },
};
</script>
<style>
    .block {
        float: right;
    }
</style>




// WEBPACK FOOTER //
// src/components/DKType.vue